import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Div } from 'ui';

const Type = styled(Div)`
  font-size: 10px;
  line-height: 13px;
  color: ${p => p.theme.colors.text};
  text-transform: uppercase;
`;

const Name = styled(Div)`
  font-size: 16px;
  line-height: 20px;
  color: ${p => p.theme.colors.text};
`;

const OtherDetail = styled(Div)`
  font-size: 14px;
  line-height: 18px;
  color: ${p => p.theme.colors.text};
`;

const Details = ({ data, type, intl }) =>
  <>
    <Type>{type}</Type>
    <Name fontWeightBolder>{data.name}</Name>
    <OtherDetail>
      {intl.formatMessage({ id: 'order.changePartner.SAP_ID' }, { number: data.number })}
    </OtherDetail>
    <OtherDetail>
      {intl.formatMessage({ id: 'order.changePartner.VISIT_TYPE' }, { visitType: data.visitType })}
    </OtherDetail>
    <OtherDetail>
      {intl.formatMessage(
        { id: 'order.changePartner.PLANNED_DATE' },
        { date: intl.formatDate(data.scheduledDate) },
      )}
    </OtherDetail>
  </>;
Details.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(Details);
